export default {
  'en-US': {
    platformSources: {
      Ebay: 'eBay',
      Shopify: 'Shopify',
      NA: 'NA',
      BigCommerce: 'BigCommerce',
      Magento: 'Magento',
      ShipStation: 'ShipStation',
      Amazon: 'Amazon',
      WooCommerce: 'WooCommerce',
      API: 'API',
      BackerKit: 'BackerKit',
      ShipBob: 'ShipBob',
      CrateJoy: 'CrateJoy',
      Stitchlabs: 'Stitchlabs',
      QuickBooks: 'QuickBooks',
      ExcelUpload: 'Excel Upload',
      Walmart: 'Walmart',
      TicTail: 'TicTail',
      SquareSpace: 'SquareSpace',
      WooCommerceV2: 'WooCommerce',
      SquareConnect: 'SquareConnect',
      Returnly: 'Returnly',
      Sps: 'SPS'
    }
  },
  'ja-JP': {
    platformSources: {
      Ebay: 'eBay',
      Shopify: 'Shopify',
      NA: 'NA',
      BigCommerce: 'BigCommerce',
      Magento: 'Magento',
      ShipStation: 'ShipStation',
      Amazon: 'Amazon',
      WooCommerce: 'WooCommerce',
      API: 'API',
      BackerKit: 'BackerKit',
      ShipBob: 'ShipBob',
      CrateJoy: 'CrateJoy',
      Stitchlabs: 'Stitchlabs',
      QuickBooks: 'QuickBooks',
      ExcelUpload: 'Excel Upload',
      Walmart: 'Walmart',
      TicTail: 'TicTail',
      SquareSpace: 'SquareSpace',
      WooCommerceV2: 'WooCommerce',
      SquareConnect: 'SquareConnect',
      Returnly: 'Returnly',
      Sps: 'SPS'
    }
  }
}
